export enum PaymentTypes{
    CASH='CASH',
    CHEQUE='CHEQUE',
    BANK_TRANSFER='BANK TRANSFER'
}